import { render, staticRenderFns } from "./BlockBlogHeader.vue?vue&type=template&id=7cdf5c4e&scoped=true&"
import script from "./BlockBlogHeader.vue?vue&type=script&lang=js&"
export * from "./BlockBlogHeader.vue?vue&type=script&lang=js&"
import style0 from "./BlockBlogHeader.vue?vue&type=style&index=0&id=7cdf5c4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdf5c4e",
  null
  
)

export default component.exports